<template>
    <v-container fluid class="pa-0">
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                My Centers
              </div>
            </div>
          </v-col>
          <v-card-actions>
              <router-link slot="right" :to="{ name: 'amsSchedulingDashboard' }">
                <v-btn
                  elevation="1"
                  absolute
                  right
                  top

                >
                  <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                >
              </router-link>
            </v-card-actions>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" sm="2" xs="12" v-if="isSuperAdmin">
            <v-autocomplete
              key="id"
              :items="zoneList"
              v-model="zoneID"
              item-text="name"
              item-value="id"
              @change="getAcademicManagerList()"
              :error-messages="zoneErrorMes"
            >
              <template v-slot:label> Zone </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" sm="2" xs="12" v-if="isSuperAdmin">
            <v-autocomplete
              name="id"
              :items="academicManagerList"
              v-model="academicManagerID"
              item-value="amUserId"
              item-text="academicManagerName"
              :error-messages="acmaErrorMes"
            >
              <template v-slot:label> Academic Manager </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="2" lg="3" sm="2" xs="12" v-if="isSuperAdmin">
            <div class="d-flex justify-end caption">
              <v-btn

                small
                id="apply"
                color="success"
                elevation="1"
                type="submit"
                class="ml-2 mt-5"
                @click="getMyCenterData(academicManagerID)"

              >
                <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
                Proceed
              </v-btn>
              <v-btn
                style="margin-right: 20px;"
                small
                elevation="1"
                type="reset"
                @click="resetAll()"
                class="ml-2 mt-5"
              >
                <v-icon left size="18"> mdi-restart</v-icon> Clear
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-data-table
        style="margin-top: 25px;"
        :headers="headers"
        :items="allocateCenter"
      ></v-data-table>
      </v-card>
    </v-container>
</template>

<script>
import stores from '@/stores'
import constants from '@/utils/constants'
import moment from 'moment'

export default {
  name: 'myCenters',
  data () {
    return {
      headers: [
        {
          text: 'Center Name',
          value: 'franchisee.companyName',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Center Email ID',
          value: 'franchisee.email',
          sortable: true,
          align: 'center'
        },
        {
          text: 'City',
          value: 'franchisee.city',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Pin Code',
          value: 'franchisee.pincode',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Allocated At',
          value: 'updatedAt',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Center Category',
          value: 'franchisee.amsCenterCategory.name',
          sortable: true,
          align: 'center'
        }
      ],
      allocateCenter: [],
      isSuperAdmin: false,
      amUserId: '',
      zoneList: [],
      zoneID: '',
      academicManagerID: '',
      academicManagerList: [],
      acmaErrorMes: '',
      zoneErrorMes: ''
    }
  },
  created: async function () {
    let userStore = stores.user
    this.isSuperAdmin = userStore.ACL.superAdmin
    this.amUserId = stores.user.me.id

    if (this.isSuperAdmin === false) {
      await this.getMyCenterData(this.amUserId)
    }
    if (this.isSuperAdmin) {
      await this.getZones()
    }
  },
  methods: {
    getMyCenterData: async function (userID) {
      try {
        if (this.isSuperAdmin) {
          if (!this.zoneID) {
            this.zoneErrorMes = 'Please Select Zone'
            return
          }
          if (!this.academicManagerID) {
            this.acmaErrorMes = 'Please Select Academic Manager'
            return
          }
          this.zoneErrorMes = ''
          this.acmaErrorMes = ''
        }

        const response = await http.get(
          `${constants.API_URL}/api/ams/get/ams-center-details?userID=${userID}`
        )
        console.log(response)
        this.allocateCenter = response.data.amsCenterAllocations ? response.data.amsCenterAllocations : []
        for (const item of this.allocateCenter) {
          item.updatedAt = moment(item.updatedAt).format('DD/MM/YYYY')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getZones: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/get/zones`
        )
        this.zoneList = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getAcademicManagerList: async function () {
      try {
        this.academicManagerID = ''
        this.allocateCenter = []
        let payload = {}
        payload.zoneId = this.zoneID ? this.zoneID : ''
        const response = await http.post(
          `${constants.API_URL}/api/amsScheduling/configuration/firstAudit/getAcademicManagerList`, payload
        )
        this.academicManagerList = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    resetAll () {
      this.zoneID = ''
      this.academicManagerID = ''
      this.academicManagerList = []
      this.allocateCenter = []
      this.zoneErrorMes = ''
      this.acmaErrorMes = ''
    }
  }
}

</script>
